import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';

@Component({
  selector: 'app-domain-redirect-dialog',
  templateUrl: './domain-redirect-dialog.component.html',
  styleUrls: ['./domain-redirect-dialog.component.scss'],
})
export class DomainRedirectDialogComponent implements OnInit, OnDestroy {
  isDesktop: boolean;
  newDomainUrl: string = 'https://lemoncasinohu28.com';
  countdown: number = 3;

  private countdownInterval: any;

  constructor(
    public dialogRef: MatDialogRef<DomainRedirectDialogComponent>,
    public detectDeviceService: DetectDeviceService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    this.isDesktop = this.detectDeviceService.isDesktop();
    if (isPlatformBrowser(this.platformId)) {
      this.newDomainUrl = `https://lemoncasinohu28.com${window.location.pathname}${window.location.search}`;
      this.startCountdown();
    }
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.goToNewDomain();
      }
    }, 1000);
  }

  goToNewDomain(): void {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this.countdownInterval);
      window.location.href = this.newDomainUrl;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownInterval);
  }
}
